import { billingEnabled } from 'app/config';
import { getProjectJS, getProjectPath } from 'app/project/selectors';
import { useSelector } from 'react-redux';
import { getCurrentBranchPath } from '../../../../branches/selectors';
import { useDropdownClose } from '../../../daisy/dropdown';

export const useSettingsNav = () => {
  const project = useSelector(getProjectJS);
  const projectPath = useSelector(getProjectPath);
  const branchPath = useSelector(getCurrentBranchPath);
  const close = useDropdownClose();

  const showBilling = billingEnabled;

  return { project, projectPath, branchPath, showBilling, close };
};

export type SettingsNavProps = ReturnType<typeof useSettingsNav>;
